// extracted by mini-css-extract-plugin
export default {"close":"ButtonClose_close__a+xBT"};